import { ICall } from '../../../types/call';
import { IVoximplantCall } from '../../../types/external/Voximplant';
import str from '../Stringable';

export default class CallHelpers {
  public static fromVoximplan(call: IVoximplantCall): ICall {
    return {
      id: call.id,
      caller: str(call.phone_a).start('+').toString(),
      recipient: str(call.phone_b).start('+').toString(),
      is_incoming: call.incoming,
    };
  }
}
